export type SessionScope = "me" | "team";

export type TrainingEvalRunScope = { kind: "me" } | { kind: "team"; groupUuid: string };

// member·experiment 필터의 전체 선택 sentinel.
export const ALL_SESSION_FILTER = "";

// Evaluation API의 반복 policy_id 필터 상한과 같다.
export const MAX_POLICY_SELECTION = 15;

// Evaluation Results가 정책 필터와 창 identity에 쓰는 최소 정책 참조.
export type SelectedPolicyRef = {
  policyId: string;
  policyName: string;
};

// Evaluation은 Training의 구체 테이블 구현 대신 정책 선택을 읽는 이 포트에만 의존한다.
export type PolicySelectionReader = {
  subscribe: (onStoreChange: () => void) => () => void;
  resolvePolicyRefs: (ids: readonly string[]) => readonly SelectedPolicyRef[] | null;
  getSelectedPolicies: () => readonly SelectedPolicyRef[];
};

// 화면 스코프를 eval-run 질의 스코프로 바꾼다. 그룹을 해석하지 못한 team은 조회 대상이 없다.
// 그래서 null이다.
export function toEvalRunScope(
  scope: SessionScope,
  groupUuid: string | null,
): TrainingEvalRunScope | null {
  return scope === "me" ? { kind: "me" } : groupUuid !== null ? { kind: "team", groupUuid } : null;
}
